import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms/forms';
import {DirectoryService} from '../../../services/directory.service';
import {ApiClientService} from '../../../services/api-client.service';
import {ConstantsService} from '../../../services/constants.service';
import {PhoneTransformer} from '../../../services/transformer.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'send-sms-modal',
    templateUrl: './send-sms-modal.component.html',
    styleUrls: ['./send-sms-modal.component.scss']
})

export class SendSmsModalComponent implements OnInit {
    message = '';
    showModal = false;
    disabledSubmit = false;
    showSpinner = false;
    somethingChanged = false;
    spinnerShow = false;
    cellPhone = '';

    constructor(
        public directoryService: DirectoryService,
        public api: ApiClientService
    ) {}

    ngOnInit() {
        this.cellPhone = this.directoryService.smsMessageResidentData.cellPhones[0].phone;
        this.initSummernote();
    }

    onSubmit(form: NgForm): void {
        const message = this.message.replace(/<br>/g, '\n').replace(/<[^>]*>/g, '\n').replace(/&nbsp;/g, ' ');
        if(!message) {
            toastr.error(`Message must not be empty.`);
            return;
        }
        this.disabledSubmit = true;
        this.showSpinner = true;
        const data = {
            ...this.directoryService.smsMessageResidentData,
            recipientPhone: this.cellPhone,
            text: message
        };
        delete data.cellPhones;
        this.api.post('domainSms', '/v1/sms_message', data).subscribe(
            (response) => {
                toastr.success(`Message has been sent successfully.`);
                this.hideModal(form, true);
            },
            error => {
                this.api.errorHandler(error, `Failed to send message`);
                this.disabledSubmit = false;
                this.showSpinner = false;
            }
        );
    }

    hideModal(form, closeOnSubmit?) {
        if (this.somethingChanged && !closeOnSubmit) {
            swal(ConstantsService.getSwalConfig('Exit without saving?', 'If you close the dialog, the data you have entered will be lost'),
                () => {
                    this.directoryService.showSmsModal = false;
                    this.directoryService.smsMessageResidentData = null;
                }
            );
        } else {
            this.directoryService.showSmsModal = false;
            this.directoryService.smsMessageResidentData = null;
        }
    }

    initSummernote() {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: {
                onChange: contents => {
                    this.somethingChanged = true;
                    this.message = contents;
                },
                onKeydown: event => {
                    if(event.keyCode != 8 && event.target.textContent.length >= 500)
                        event.preventDefault();
                },
                onPaste: async event => {
                    event.preventDefault();
                    const clipText = await (<any>navigator).clipboard.readText();
                    if (this.message.length + clipText.length < 500)
                        document.execCommand('insertText', false, clipText);
                }
            },
            maxTextLength: 5,
            toolbar: [],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');
        $('.note-editable').html(this.message).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    getPhoneString(phone) {
        return PhoneTransformer.stringToPhone(phone);
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/directory/send-sms-modal/send-sms-modal.component.ts